import React from 'react';
import { Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const FloatingBookButton = () => {
  return (
    <Link
      to="/contact"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-gradient-to-r from-[#C4A052] to-[#B8935E] hover:from-[#B8935E] hover:to-[#C4A052] text-white font-semibold px-5 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
      data-testid="floating-book-now-btn"
    >
      <Calendar size={18} />
      <span className="text-sm">Book Now</span>
    </Link>
  );
};

export default FloatingBookButton;
